import { useState } from "react";
import { supabase } from "../lib/supabase";
import { Lock, Eye, EyeOff } from "lucide-react";

export default function ForceChangePassword({ profile, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("A senha deve ter pelo menos 6 caracteres");
      return;
    }
    if (password !== confirm) {
      setError("As senhas não conferem");
      return;
    }

    setBusy(true);

    const { error: updateErr } = await supabase.auth.updateUser({ password });

    if (updateErr) {
      setError(updateErr.message);
      setBusy(false);
      return;
    }

    await supabase
      .from("profiles")
      .update({ must_change_password: false })
      .eq("id", profile.id);

    setBusy(false);
    onDone();
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px 10px 40px",
    border: "1px solid rgba(128,128,128,0.08)",
    borderRadius: 8,
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "rgba(128,128,128,0.08)",
    color: "#555",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #251C59 0%, #1e3a5f 50%, #0f172a 100%)",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        padding: 20,
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 15,
          padding: "40px 36px",
          width: "100%",
          maxWidth: 420,
          boxShadow: "0 25px 50px rgba(0,0,0,0.25)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img
            src="/logo-icon.png"
            alt="InstaSolutions"
            style={{ width: 64, height: 64, marginBottom: 12 }}
          />
          <h1 style={{ fontSize: 20, fontWeight: 700, color: "#251C59", margin: 0 }}>
            Altere sua senha
          </h1>
          <p style={{ fontSize: 13, color: "#555", margin: "8px 0 0" }}>
            Por segurança, você precisa definir uma nova senha antes de continuar.
          </p>
        </div>

        {error && (
          <div
            style={{
              background: "#fef2f2",
              border: "1px solid #fecaca",
              borderRadius: 8,
              padding: "10px 14px",
              marginBottom: 16,
              color: "#C02646",
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#555",
                display: "block",
                marginBottom: 6,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Nova senha
            </label>
            <div style={{ position: "relative" }}>
              <Lock
                size={16}
                style={{ position: "absolute", left: 12, top: 13, color: "#94a3b8" }}
              />
              <input
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                style={{ ...inputStyle, paddingRight: 40 }}
              />
              <button
                type="button"
                onClick={() => setShowPw(!showPw)}
                style={{
                  position: "absolute",
                  right: 10,
                  top: 11,
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                {showPw ? <EyeOff size={16} color="#94a3b8" /> : <Eye size={16} color="#94a3b8" />}
              </button>
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#555",
                display: "block",
                marginBottom: 6,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
              }}
            >
              Confirme a nova senha
            </label>
            <div style={{ position: "relative" }}>
              <Lock
                size={16}
                style={{ position: "absolute", left: 12, top: 13, color: "#94a3b8" }}
              />
              <input
                type={showPw ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Repita a senha"
                required
                minLength={6}
                style={inputStyle}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={busy}
            style={{
              width: "100%",
              padding: "12px 0",
              border: "none",
              borderRadius: 8,
              background: busy ? "#94a3b8" : "#251C59",
              color: "#fff",
              fontSize: 14,
              fontWeight: 500,
              fontFamily: "inherit",
              cursor: busy ? "not-allowed" : "pointer",
            }}
          >
            {busy ? "Salvando..." : "Definir nova senha"}
          </button>
        </form>
      </div>
    </div>
  );
}
